import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import type { Entity } from '../../core/models/entity.model';
import { EntityService } from '../../core/services/entity.service';

@Injectable({
  providedIn: 'root'
})
export class AuthEntitiesService {
  constructor(private entityService: EntityService) {}

  getLoginEntity(): Observable<Entity[]> {
    return this.entityService.createOrUpdateTemporaryEntity('UserLogin', []);
  }
}
